module.exports = __webpack_public_path__ + "img/teacher.00a0a437.png";